var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1043_11814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8203 8.5C17.3726 8.5 17.8203 8.05228 17.8203 7.5C17.8203 6.94772 17.3726 6.5 16.8203 6.5C16.268 6.5 15.8203 6.94772 15.8203 7.5C15.8203 8.05228 16.268 8.5 16.8203 8.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8203 17C17.3726 17 17.8203 16.5523 17.8203 16C17.8203 15.4477 17.3726 15 16.8203 15C16.268 15 15.8203 15.4477 15.8203 16C15.8203 16.5523 16.268 17 16.8203 17Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8203 25.5C17.3726 25.5 17.8203 25.0523 17.8203 24.5C17.8203 23.9477 17.3726 23.5 16.8203 23.5C16.268 23.5 15.8203 23.9477 15.8203 24.5C15.8203 25.0523 16.268 25.5 16.8203 25.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1043_11814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.820312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/threeDots.513cb0cffa02c2f4bb7c65e755292bc3.svg";
export { ForwardRef as ReactComponent };